import {
  GlobalCompanyTabCompanyType,
  GlobalCompanyTabName,
  GlobalCompanyTabNanoID,
  GlobalCompanyTabPosition,
  GlobalCompanyTabRoleUID,
  CreateGlobalCompanyTabCacheKeys,
  CreateGlobalCompanyTabGqlQuery
} from '../../globalCompanyTabsTypes';

import { useEdCreateQuery } from '../../../common/reactQuery/hooks/useEdCreateQuery';
import { ErrorType } from '../../../../utils/parseRequestError';

interface CreateGlobalCompanyTabOptions {
  query: CreateGlobalCompanyTabGqlQuery;
  cacheKeys?: CreateGlobalCompanyTabCacheKeys;
}

export interface CreateGlobalCompanyTabInput {
  nanoId?: GlobalCompanyTabNanoID;
  companyType: GlobalCompanyTabCompanyType;
  name: GlobalCompanyTabName;
  content?: string;
  position?: GlobalCompanyTabPosition;
  roleUids?: GlobalCompanyTabRoleUID[];
}

export type CreateGlobalCompanyTabError = ErrorType;

const action = 'createGlobalCompanyTab';

function useCreateGlobalCompanyTab<CreateGlobalCompanyTabRecordType = unknown>({
  query,
  cacheKeys
}: CreateGlobalCompanyTabOptions) {
  const {
    createQuery,
    createQueryData,
    createQueryError,
    createQueryErrorMessage,
    createQueryLoading,
    createQueryReset
  } = useEdCreateQuery<
    CreateGlobalCompanyTabInput,
    CreateGlobalCompanyTabRecordType,
    CreateGlobalCompanyTabError,
    CreateGlobalCompanyTabRecordType
  >({ action, query, cacheKeys });

  return {
    createGlobalCompanyTab: createQuery,
    createGlobalCompanyTabData: createQueryData,
    createGlobalCompanyTabError: createQueryError,
    createGlobalCompanyTabErrorMessage: createQueryErrorMessage,
    createGlobalCompanyTabLoading: createQueryLoading,
    createGlobalCompanyTabReset: createQueryReset
  };
}

export default useCreateGlobalCompanyTab;
